export default __webpack_public_path__ + "static/media/Steam.de6d3e6f.svg";